import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { ArtistPriorCity } from 'app/shared/typings/cities';
import { NavigationLink, Typography } from 'app/shared/components/atoms';

interface Props {
  name: string;
  cities?: ArtistPriorCity[];
}

const CityLink = ({ city }: { city: ArtistPriorCity }) => {
  return (
    <NavigationLink variant="primary" href={`/cities/${city.cachedSlug}`}>
      Sofar {city.title}
    </NavigationLink>
  );
};

const renderArtistPriorCities = (
  cities: ArtistPriorCity[],
  andText: string
) => {
  return cities.map(
    (city: ArtistPriorCity, index: number, { length }: { length: number }) => {
      switch (index) {
        case 0:
          return (
            <React.Fragment key={index}>
              <CityLink city={city} />
            </React.Fragment>
          );
        case length - 1:
          return (
            <React.Fragment key={index}>
              {length > 2 && ','} {andText}
              <CityLink city={city} />
            </React.Fragment>
          );
        default:
          return (
            <React.Fragment key={index}>
              , <CityLink city={city} />
            </React.Fragment>
          );
      }
    }
  );
};

const ArtistPriorCities: React.FC<React.PropsWithChildren<Props>> = ({
  name,
  cities,
}) => {
  const intl = useIntl();
  const { colors } = useCurrentTheme();

  if (!cities || !cities.length) {
    return null;
  }

  return (
    <Typography
      data-qaid="artist-prior-acts-text"
      color={colors.primary.white.base}
    >
      {intl.formatMessage({ id: 'artist.performedIn' }, { name })}
      {renderArtistPriorCities(
        cities,
        intl.formatMessage({ id: 'artist.and' })
      )}
      .
    </Typography>
  );
};

export default ArtistPriorCities;
